import regeneratorRuntime from "/app/node_modules/next/dist/compiled/regenerator-runtime/runtime.js";
import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useRouter } from 'next/router';
import getBlockServices from '@/api/blocks';
import { makeBlockDetailLink } from '@/utils/link';
import Linker from '@/components/base/Linker';
import clss from 'classnames';
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
var cache = {};
var blockService = getBlockServices();
function BlockHeightLink(param) {
    var height = param.height, shardIndex = param.shardIndex, _isLinker = param.isLinker, isLinker = _isLinker === void 0 ? false : _isLinker, className = param.className;
    var router = useRouter();
    var ref = useState(''), blockHash = ref[0], setBlockHash = ref[1];
    var getBlockByHeight = useCallback(_asyncToGenerator(regeneratorRuntime.mark(function _callee() {
        var cacheKey, Result, block;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    cacheKey = "".concat(height.toString(), ":").concat(shardIndex.toString());
                    if (!cache[cacheKey]) {
                        _ctx.next = 3;
                        break;
                    }
                    return _ctx.abrupt("return", cache[cacheKey]);
                case 3:
                    _ctx.next = 5;
                    return blockService.getShardBlocks({
                        height: height,
                        shardIndex: shardIndex
                    });
                case 5:
                    Result = _ctx.sent.Result;
                    block = Result === null || Result === void 0 ? void 0 : Result.ListData[0];
                    cache[cacheKey] = block === null || block === void 0 ? void 0 : block.Hash;
                    return _ctx.abrupt("return", block === null || block === void 0 ? void 0 : block.Hash);
                case 9:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), [
        height,
        shardIndex
    ]);
    useEffect(function() {
        if (isLinker) {
            getBlockByHeight().then(function(bHash) {
                bHash && setBlockHash(bHash);
            });
        }
    }, [
        isLinker,
        height,
        getBlockByHeight
    ]);
    var gotoBlockByHeight = useCallback(_asyncToGenerator(regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    getBlockByHeight().then(function(bHash) {
                        bHash && router.push(makeBlockDetailLink(bHash));
                    });
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), [
        getBlockByHeight
    ]);
    var linkUrl = useMemo(function() {
        return makeBlockDetailLink(blockHash);
    }, [
        blockHash
    ]);
    return isLinker ? /*#__PURE__*/ _jsx(Linker, {
        className: className,
        href: linkUrl,
        text: String(height)
    }) : /*#__PURE__*/ _jsx("div", {
        className: clss(className, 'text-primary cursor-pointer'),
        onClick: gotoBlockByHeight,
        children: "".concat(height)
    });
}
export default BlockHeightLink;
